export function hasTournamentCapacityLimit(
	maxParticipants: number | null | undefined,
) {
	return Number(maxParticipants ?? 0) > 0;
}

export function isTournamentAtCapacity(
	activeSlots: number,
	maxParticipants: number | null | undefined,
) {
	return (
		hasTournamentCapacityLimit(maxParticipants) &&
		activeSlots >= Number(maxParticipants)
	);
}

export function formatTournamentCapacityCount(
	current: number,
	maxParticipants: number | null | undefined,
) {
	if (!hasTournamentCapacityLimit(maxParticipants)) {
		return String(current);
	}

	return `${current} / ${Number(maxParticipants)}`;
}
